import React, { useContext } from 'react'
import { AppFormAction } from 'api'
import { Icon } from 'antd'
import { AppGridLayoutDesigerContext } from './AppGridLayoutDesigerContext'
export interface Props {
	type: string
	appActionList: AppFormAction[]
	onChange: (appActionList: AppFormAction[], type: string) => void
}
export const ButtonDrag = (props: Props) => {
	const context = useContext(AppGridLayoutDesigerContext)
	const delButton = (index: number) => {
		let appActionList = props.appActionList
		appActionList.splice(index, 1)
		props.onChange(appActionList, props.type)
	}
	return (
		<div className="toolbar-item-drag">
			{props.appActionList.map((appAction: AppFormAction, index: number) => {
				return (
					<div
						key={index}
						className={`ui button ${
							context.currSelectd.type === props.type && context.currSelectd.field === index.toString()
								? 'chosen'
								: ''
						}`}
						draggable="false"
						onClick={e =>
							context.setCurrSelected({
								type: props.type,
								field: index.toString(),
							})
						}
					>
						<span title="点击编辑，拖动交换位置">{appAction.title}</span>
						<Icon type="close" className="remove" onClick={e => delButton(index)}></Icon>
					</div>
				)
			})}
		</div>
	)
}



// WEBPACK FOOTER //
// ./src/modules/modeling/page/AppGridLayoutDesiger/ButtonDrag.tsx